function check(password?: string) {
  if (!password) return false
  return /[A-Z]/.test(password)
}

export default {
  check,
}
